import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  title: string;
  body: string;
};

const Description: FC<Props> = ({ title, body }) => {
  return (
    <div className={styles.detail}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{body}</div>
    </div>
  );
};

export default Description;
